<script setup>
import { default as ButtonEl } from '@/components/shared/Button.vue';

const emit = defineEmits(['previous', 'next', 'autoplay-toggled', 'close']);

defineProps({
  totalSlides: {
    type: Number,
    default: 0,
  },
  currentSlide: {
    type: Number,
    default: 1,
  },
  autoplay: {
    type: Boolean,
    default: true,
  },
  isAutoPlaying: {
    type: Boolean,
    default: false,
  },
  hideNavigation: {
    type: Boolean,
    default: false,
  },
});

function goToPrevious() {
  emit('previous');
}

function goToNext() {
  emit('next');
}

function toggleAutoplay() {
  emit('autoplay-toggled');
}
</script>

<template>
  <div class="flex flex-row items-center justify-between w-full px-16 h-48">
    <div
      class="text-neutral-0 flex w-1/3"
      v-if="autoplay"
      @click="toggleAutoplay"
    >
      <fa-icon
        :icon="['fas', `${isAutoPlaying ? 'pause' : 'play-circle'}`]"
        class="text-3xl mr-2"
      />
      <span class="h700">{{
        isAutoPlaying ? $t('global.stopAutoplay') : $t('global.autoplay')
      }}</span>
    </div>

    <div class="w-1/3" v-else></div>

    <div class="w-1/3 flex justify-center">
      <ButtonEl
        class="content bold"
        text="global.close"
        :icon="['fas', 'fa-times']"
        background="bg-neutral-0"
        textColor="text-neutral-1000"
        rounded="full"
        @click="$emit('close')"
      />
    </div>

    <!-- Navigation -->
    <div
      v-if="!hideNavigation"
      class="text-neutral-0 h600 text-center w-1/3 flex justify-end items-center"
    >
      <div
        class="w-12 h-12 flex items-center justify-center"
        @click="goToPrevious"
      >
        <fa-icon
          class="text-white content light text-2xl"
          :icon="['fa', 'chevron-left']"
        />
      </div>

      <span class="content">{{ currentSlide }} / {{ totalSlides }}</span>

      <div class="w-12 h-12 flex items-center justify-center" @click="goToNext">
        <fa-icon
          class="text-white text-2xl content light"
          :icon="['fa', 'chevron-right']"
        />
      </div>
    </div>
  </div>
</template>
